export default __webpack_public_path__ + "static/media/Slide14.b38a0606.PNG";